import { render, staticRenderFns } from "./customerOrderRead.vue?vue&type=template&id=70ee74d6&scoped=true&"
import script from "./customerOrderRead.vue?vue&type=script&lang=js&"
export * from "./customerOrderRead.vue?vue&type=script&lang=js&"
import style0 from "./customerOrderRead.vue?vue&type=style&index=0&id=70ee74d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee74d6",
  null
  
)

export default component.exports